import { useEffect, useState } from "react"
import { getAllDepartamentosV2 } from "../../../Services/departamentoService"
import { useFormik } from "formik"
import * as Yup from "yup"
import { saveFamilias } from "../../../Services/familiaService"
import { saveError } from "../../../Services/errorService"
import Swal from "sweetalert2"

const useAddFamily = (history) => {
  const [departamentos, setDepartamentos] = useState([])

  useEffect(() => {
    getAllDepartamentosV2(true, 0, '', 100)
      .then((res) => setDepartamentos(res.data.content))
      .catch((err) => console.error(err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      setDepartamentos(null)
    }
  }, [])

  // validacion del formulario
  const formik = useFormik({
    initialValues: {
      nombre: '',
      ganancia: 0,
      departamento: '',
    },
    validationSchema: Yup.object({
      nombre: Yup.string().required('Obligatorio.'),
      ganancia: Yup.number()
        .required('Obligatorio.')
        .min(0, 'El numero debe ser positivo.'),
      departamento: Yup.object().required('Obligatorio.'),
    }),
    onSubmit: (values) => addFamilia(values),
  })

  const addFamilia = (values) => {
    // creamos el objeto
    let familia = {
      nombre: values.nombre,
      ganancia: values.ganancia,
      departamentoId: values.departamento.id,
    }

    // creamos la familia
    saveFamilias(familia)
      .then((res) => {
        history.goBack()
      })
      .catch(async (error) => {
        const errorData = {
          mensaje: 'Error al intentar crear a una familia',
          detalle: error.message,
          entidad: 'FAMILIA',
          tipo: 'WEBAPP',
          severidad: 'HIGH',
          reportado: 'APPLICATION',
        }

        await saveError(errorData)
        Swal.fire({
          text: 'Error al crear la familia, verifique los datos.',
          type: 'error',
          showConfirmButton: false,
          timer: 1500,
        })
        console.error(error)
      })
  }
  return { departamentos, formik }
}

export default useAddFamily